import { useEffect, useState, useRef } from 'react';

export function useHeadsObserver() {
  const [activeId, setActiveId] = useState('');
  const observer = useRef();

  useEffect(() => {
    const handleObsever = (entries) => {
      const visibleEntries = entries.filter((entry) => entry.isIntersecting);

      if (visibleEntries.length > 0) {
        // Фильтруем только H2 заголовки для оглавления
        const h2Entries = visibleEntries.filter((entry) => entry.target.nodeName === 'H2');

        if (h2Entries.length > 0) {
          // Находим H2 элемент, который наиболее виден
          const mostVisibleH2 = h2Entries.reduce((prev, current) => {
            const prevRatio = prev.intersectionRatio;
            const currentRatio = current.intersectionRatio;
            return currentRatio > prevRatio ? current : prev;
          });
          setActiveId(mostVisibleH2.target.id);
        } else {
          // Если H2 не видны, находим ближайший H2 сверху от текущего видимого элемента
          const allElements = Array.from(document.querySelectorAll('.toc'));
          const firstVisibleEntry = visibleEntries[0];

          if (firstVisibleEntry) {
            const visibleIndex = allElements.indexOf(firstVisibleEntry.target);
            const previousH2 = allElements.slice(0, visibleIndex).reverse().find((elem) => elem.nodeName === 'H2');

            if (previousH2) {
              setActiveId(previousH2.id);
            }
          }
        }
      }
    };

    observer.current = new IntersectionObserver(handleObsever, {
      rootMargin: '-10% 0% -60% 0px',
      threshold: [0, 0.1, 0.2, 0.5, 1.0],
    });

    const elements = document.querySelectorAll('.toc');
    elements.forEach((elem) => observer.current.observe(elem));
    return () => observer.current?.disconnect();
  }, []);

  return { activeId };
}
